import React from 'react'
import './checkbox.scss'

interface CheckboxProps {
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
    darkMode?: boolean
    disabled?: boolean
    className?: string
}

export const CustomCheckbox: React.FC<CheckboxProps> = ({
    label,
    checked,
    onChange,
    darkMode = false,
    disabled = false,
    className = ''
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            onChange(e.target.checked)
        }
    }

    return (
        <label className={`custom-checkbox ${darkMode ? 'dark-mode' : ''} ${disabled ? 'disabled' : ''} ${className}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                className="checkbox-input"
            />
            <span className="checkbox-checkmark">
                {checked && (
                    <svg 
                        className="checkbox-icon" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path 
                            d="M9 16.17l-4.17-4.17-1.42 1.41L9 19 21 7l-1.41-1.41z" 
                            fill="currentColor"
                        />
                    </svg>
                )}
            </span>
            <span className="checkbox-label">{label}</span>
        </label>
    )
}
